'use client';

import React, { useEffect, useState } from 'react';
import { useRegionPricing } from '@/features/payment/hooks/useRegionPricing';

interface MockPaymentProps {
    isActive: boolean;
    onComplete: () => void;
}

export function MockPayment({ isActive, onComplete }: MockPaymentProps) {
    const { discountedPriceText } = useRegionPricing();
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        if (isActive) {
            runSequence();
        } else {
            setIsProcessing(false);
        }
    }, [isActive]);

    const runSequence = async () => {
        await wait(1000); // Let user see the modal
        // Simulate Click Pay
        const btn = document.getElementById('mock-pay-btn');
        if (btn) btn.style.transform = "scale(0.95)";

        await wait(300);
        if (btn) btn.style.transform = "scale(1)";

        setIsProcessing(true);
        await wait(1500); // Processing payment...

        onComplete();
    };

    const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    return (
        <div className="w-full h-full absolute inset-0 z-50 flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-gray-900/40 backdrop-blur-sm animate-in fade-in duration-500"></div>

            {/* Modal */}
            <div className="relative w-full max-w-[400px] bg-white rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 fade-in duration-500 transform translate-y-0">

                {/* Minimal Header */}
                <div className="bg-white p-8 text-center">
                    <div className="w-14 h-14 bg-violet-100 rounded-full flex items-center justify-center mx-auto mb-4 animate-bounce-slow">
                        <svg className="w-7 h-7 text-violet-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
                    </div>

                    <h3 className="text-2xl font-bold text-gray-900 mb-2">Publish to Live</h3>
                    <p className="text-gray-500 mb-6">Build unlimited pages. Pay only when you publish.</p>

                    <button
                        id="mock-pay-btn"
                        className="w-full bg-black text-white py-3 rounded-xl font-bold hover:bg-gray-800 transition-all flex items-center justify-center gap-2"
                    >
                        {isProcessing ? "Processing..." : `Pay ${discountedPriceText} & Publish`}
                    </button>
                </div>
            </div>
        </div>
    );
}
